export default {
  title: '{{user}} bezahlte alle Bestellungen und "deckte den Tisch zu".',
  description:
    'Wir "räumen" deinen Tisch automatisch ab, wenn alle Bestellungen bezahlt sind. Bitte klicke auf "Weiter". P.S du kannst natürlich mehr bestellen, wenn du möchtest 😋',
  buttons: {
    continue: "Weiter",
  },
};
